// Deleted pages: how a list tells them apart.
//
// THE API HAS NO DELETED FLAG. Deleting a Xano page is a soft delete (xano/workspace-8/api/cms/project/delete_POST.xs):
// the row stays, its content is snapshotted, published=false and noindex=true, and the slug is renamed out of the
// namespace to "~trash~<page id>~<old slug>". That rename is what frees the slug and stops the public reader resolving
// it, and it is the only mark a deleted row carries: GET admin/pages, admin/pages/all and admin/search/index all still
// return these rows (45 of 656 on Charlie's account on 20 Oct 2026, at the top of /pages because they were updated
// last). So every list reads the prefix. published=false alone is not it: drafts are unpublished too.

const TRASH = /^\/?~trash~\d+~/;

export function isTrashedPage(page: { slug?: string | null }): boolean {
  return TRASH.test(page.slug ?? "");
}

/** The slug a deleted page had before it was deleted ("~trash~683~coconuts" → "coconuts"); other slugs unchanged. */
export function trashedOriginalSlug(slug: string): string {
  return slug.replace(TRASH, "");
}

/** A list without its deleted pages. */
export function withoutTrashed<T extends { slug?: string | null }>(pages: readonly T[]): T[] {
  return pages.filter((p) => !isTrashedPage(p));
}
